import { render } from "./NewAllInformationDialog.vue?vue&type=template&id=1882c064&scoped=true"
import script from "./NewAllInformationDialog.vue?vue&type=script&lang=js"
export * from "./NewAllInformationDialog.vue?vue&type=script&lang=js"

import "./NewAllInformationDialog.vue?vue&type=style&index=0&id=1882c064&lang=stylus&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1882c064"]])

export default __exports__